__turbopack_context__.v({
  "badge": "tickerCell-module-scss-module__8dEUda__badge",
});
